import { useEffect, useState } from 'react';
import { classNames, profileName } from 'src/utilities';
import { Image } from '.';
import { useSelector } from 'react-redux';
import { generateColor } from '../../../SuperAdmin/components/pageComponents/SuperAdmin/Prompts/utils';

export const ProfileLogo = ({
  base64Image = null,
  name = '? ?',
  className,
}) => {
  const { encounterList } = useSelector((state) => state?.encounterState);
  const [encounterListWithColors, setEncounterListWithColors] = useState(() => {
    // Initial state with a generated color for the given name
    const initialColors = {};
    initialColors[name] = generateColor(name);
    return initialColors;
  });
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    if (encounterList) {
      const newEncounterListWithColors = { ...encounterListWithColors };
      encounterList.forEach((encounter) => {
        const practitionerName = `${encounter.practitioner_first_name} ${encounter.practitioner_last_name}`;
        if (practitionerName && !newEncounterListWithColors[practitionerName]) {
          const color = generateColor(practitionerName);
          newEncounterListWithColors[practitionerName] = color;
        }
      });
      setEncounterListWithColors(newEncounterListWithColors);
    }
    // TODO: check useeffect dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [encounterList]);

  if (base64Image && !imgError) {
    return (
      <div
        className={classNames(
          'profile-picture flex-shrink-0',
          className ? className : ''
        )}
      >
        <Image
          className=""
          src={base64Image}
          alt="user"
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'profile-picture-name flex-shrink-0 flex justify-center items-center',
        className ? className : ''
      )}
      style={{
        background: encounterListWithColors[name] || generateColor(name),
      }}
    >
      {name && profileName(name)}
    </div>
  );
};
